/* Custom js here */
$(document).ready(function() {
  // Track which element opened the modal so we can return focus on close
  let lastFocusedElement = null;

  // ===== Focus management for jQuery Modal (ADA #27) =====

  // Capture the trigger element BEFORE the modal opens
  $(document).on('mousedown keydown', '[data-modal-trigger], #cart_email_modal_mobile, #cart_email_modal_desktop, .cart_email_modal', function(e) {
    // For keydown, only track Enter/Space (actual activation keys)
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return;
    }
    lastFocusedElement = this;
  });

  // When ANY modal opens, move focus into it
  $(document).on($.modal.OPEN, function(event, modal) {
    const $modal = modal.$elm;
    const $focusable = $modal.find(
      'input:visible:not([type="hidden"]):not([disabled]), ' +
      'textarea:visible:not([disabled]), ' +
      'select:visible:not([disabled]), ' +
      'button:visible:not([disabled]), ' +
      'a[href]:visible, ' +
      '[tabindex]:not([tabindex="-1"]):visible'
    ).first();

    if ($focusable.length) {
      $focusable.focus();
    } else {
      $modal.attr('tabindex', '-1').focus();
    }
  });

  // When ANY modal closes, return focus to the triggering element
  $(document).on($.modal.AFTER_CLOSE, function(event, modal) {
    if (lastFocusedElement && document.body.contains(lastFocusedElement)) {
      // If the trigger was inside the cart drawer, reopen it
      const cartDrawer = lastFocusedElement.closest('cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.setAttribute('open', '');
        }
      }
      setTimeout(function() {
        lastFocusedElement.focus();
        lastFocusedElement = null;
      }, 50); // slightly longer delay to let drawer open animation start
    } else {
      document.body.focus();
      lastFocusedElement = null;
    }
  });

  // ===== Variant/swatch logic =====

  document.addEventListener("change", function(e) {
    var parent = e.target;
    let productForm = e.target.closest(".product-form");
    var add_btn = $(parent).closest(".product-form").find(".product-form__add-button");
    
    if (productForm) {
      let addToCart = productForm.querySelector('#AddToCart');
      let addToCartSpan = productForm.querySelector('#AddToCart span');
      var checked_cart_num = $(parent).closest(".product-form").find(".block-swatch-list .block-swatch__radio:checked").length;
      
      if (checked_cart_num > 0) {
        // Small delay to allow _updateDisableSelectors to run first
        setTimeout(function() {
          // Find the checked radio for each option group
          var sizeRadio = productForm.querySelector('.block-swatch-list .block-swatch__radio[name="option1"]:checked, .block-swatch-list .block-swatch__radio[name="option2"]:checked');
          var lengthRadio = productForm.querySelector('.block-swatch-list .block-swatch__radio[name="option2"]:checked, .block-swatch-list .block-swatch__radio[name="option3"]:checked');

          // Check if the parent swatch of any checked radio has is-disabled
          var sizeChecked = productForm.querySelectorAll('.block-swatch-list .block-swatch__radio:checked');
          var anyDisabled = false;

          sizeChecked.forEach(function(radio) {
            var parentSwatch = radio.closest('.block-swatch');
            if (parentSwatch && parentSwatch.classList.contains('is-disabled')) {
              anyDisabled = true;
            }
          });

          // Also check the currently selected combination via the variant selector
          var productVariants = productForm.closest('[class*="shopify-section"]')?.querySelector('product-variants') 
            || document.querySelector('product-variants');
          
          if (productVariants) {
            // Check if selected variant is unavailable by looking at button state
            var isVariantUnavailable = addToCart && addToCart.classList.contains('button--ternary');
            anyDisabled = anyDisabled || isVariantUnavailable;
          }

          if (!anyDisabled) {
            add_btn.prop("disabled", false);
            add_btn.removeClass('button--ternary').addClass('button--primary');
            if (addToCartSpan) addToCartSpan.textContent = 'Add to Cart';
          } else {
            add_btn.prop("disabled", true);
            add_btn.removeClass('button--primary').addClass('button--ternary');
            if (addToCartSpan) addToCartSpan.textContent = 'Sold Out';
          }
        }, 50);
      }
    }
  });

  // ===== Cart share modal triggers =====

  $(document).on("click", "#cart_email_modal_mobile", function () {
    // Build the cart permalink first
    var main_cart_url = location.origin + "/cart/";
    $("#mini-cart-form .line-item").each(function () {
      var index = parseInt($(this).attr("index"));
      var items_len = $("#mini-cart-form .line-item").length;
      var params = $(this).attr("item_id") + ":" + $(this).find(".quantity-selector__input").attr("value");
      if (items_len != index) {
        main_cart_url = main_cart_url + params + ",";
      } else {
        main_cart_url = main_cart_url + params + "?storefront=true";
      }
      $("#cart_permalink").val(main_cart_url);
    });

    // Close the cart drawer so its focus trap releases
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.close === 'function') {
      cartDrawer.close();
    } else if (cartDrawer) {
      cartDrawer.removeAttribute('open');
      document.body.classList.remove('drawer-open');
    }

    // Wait for the drawer's focus-restoration to finish before opening the modal,
    // otherwise the drawer steals focus back to the cart icon
    setTimeout(function() {
      $("#cart_form").modal();
    }, 300); // drawer close animation is usually ~250ms
  });

  $(document).on("click", "#cart_email_modal_desktop", function () {
    console.log('evt')
    $("#cart_form").modal();

    var main_cart_url = location.origin + "/cart/";
    $(".line-item-table__list .line-item").each(function () {
      var index = parseInt($(this).attr("index"));
      var items_len = $(".line-item-table__list .line-item").length;
      var params =
        $(this).attr("item_id") +
        ":" +
        $(this).find(".quantity-selector__input").attr("value");
      console.log("===params===", params);
      if (items_len != index) {
        main_cart_url = main_cart_url + params + ",";
        console.log("===params 1===", main_cart_url);
      } else {
        main_cart_url = main_cart_url + params + "?storefront=true";
        console.log("===params 2===", main_cart_url);
      }

      $("#cart_permalink").val(main_cart_url);
    });
  });

  // ===== Close button ARIA enhancements =====

  $(document).on('modal:open', function() {
    var $close = $('.jquery-modal .close-modal, .blocker .close-modal');

    $close
      .attr('role', 'button')
      .attr('tabindex', '0')
      .attr('aria-label', 'Close modal');

    $close.off('keydown.ada').on('keydown.ada', function(e) {
      if (e.key === ' ' || e.keyCode === 32) {
        e.preventDefault();
        $(this).trigger('click');
      }
    });
  });

  // ===== Share form submit =====

  document.querySelector('.js-cart-share-form')?.addEventListener('submit', async e => {
    e.preventDefault()
    const submitButton = e.target.querySelector('.js-btn-submit')
    submitButton.setAttribute('disabled', true)

    const formData = JSON.parse(JSON.stringify(Object.fromEntries(new FormData(e.target))));

    const cart = await fetch('/cart.js')
      .then(res => res.json())

    const items = cart.items.map(item => ({
      image: item.image,
      sku: item.sku,
      title: item.title,
      product_title: item.product_title,
      variant_title: item.variant_title,
      handle: item.handle,
      vendor: item.vendor,
      price: item.final_price,
      line_price: item.final_line_price,
      url: `${window.location.origin}${item.url}`,
      quantity: item.quantity
    }))

    const payload = {
      ...formData,
      cart: {
        total_price: cart.total_price,
        currency: cart.currency,
        items
      }
    }

    await fetch(e.target.getAttribute('action'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.json())

    e.target.querySelectorAll('input').forEach(input => input.value = '')
    e.target.querySelectorAll('textarea').forEach(textarea => textarea.value = '')

    // Preserve the original SHARE CART trigger across modal transitions
    const originalTrigger = lastFocusedElement;
    $.modal.close();
    submitButton.removeAttribute('disabled')

    $(".cart-share-recipient-email").text(payload['recipient_email']);
    $("#success_email_modal_id").modal();
    // Restore so the success modal's AFTER_CLOSE returns to SHARE CART
    lastFocusedElement = originalTrigger;
  })

  $(document).on("click", "#success_modal_close", function () {
    $.modal.close();
  });
});